export enum PermissionsEnum {
  //---ADMINISTRADOR (01)

  //Usuarios (01)
  Administrador_Usuarios_Administrar_Usuarios = '010101',
  Administrador_Usuarios_Administrar_Roles_Permisos = '010102',

  //Cartera (03)
  Administrador_Cartera_Seguimiento_Polizas = '010301',
  Administrador_Cartera_Seguimiento_Saldos_Vencimientos = '010302',
  Administrador_Cartera_Administrar_Debito_Automatico = '010303',

  //Renovaciones (06)
  Administrador_Renovaciones_Automoviles = '010601',
  Administrador_Multiproducto = '010602',
  Administrador_Renovaciones_Garantia_Alquiler = '010605',
  Administrador_Renovaciones_Configurar_Coeficiente_Automoviles = '010603',
  Administrador_Renovaciones_Configurar_Coeficiente_Multiseguros = '010604',
  Administrador_Renovaciones_Configurar_Precio_Garantia_Alquiler = '010606',

  //Automoviles (07)
  Sistema_Edicion_Parametros = '010701',
  Sistema_Coberturas_Paquetes = '010702',
  Sistema_Cotizaciones = '010703',
  Administrador_Automoviles_Crear_Endosos = '010704',
  Administrador_Automoviles_Editar_Precio_Paquete = '010705',

  //Multiseguros (08)
  Administrador_Multiseguros_Crear_Editar_Productos_Paquetes = '010801',
  Administrador_Multiseguros_Administrar_Productos_Paquetes_Seguimiento_Polizas = '010802',
  Administrador_Multiseguros_Crear_Endosos = '010803',

  //Transporte (09)
  Administrador_Transporte_ReadPolicy = '010901',
  Administrador_Transporte_ReadShippment = '010902',
  Administrador_Transporte_ApproveShippment = '010903',
  Administrador_Transporte_CancelShippment = '010904',
  Administrador_Transporte_BillShippment = '010905',
  Administrador_Transporte_Configuracion_Categorias = '010906',

  //Gestion de cuentas (10)
  Gestion_Cuentas = '011001',

  //Viajes (11)
  Administrador_Viajes_Seguimiento_Polizas_Cotizaciones = '011101',

  //Campañas (12)
  Crear_Campanias = '011201',

  //Fianza (13)
  Fianzas_Aprobar_Cupo = '011301',
  Fianzas_Aprobar_Poliza = '011302',

  //Siniestros (14)
  Siniestros_Ingreso = '011401',
  Siniestros_Consulta = '011402',

  //Garantía Alquiler (15)
  Administrador_GarantiaAlquiler_Seguimiento_Polizas_Cotizaciones = '011501',
  Administrador_GarantiaAlquiler_Aprobar_Cotizaciones = '011502',
  Administrador_GarantiaAlquiler_Emitir_Polizas = '011503',
  Administrador_GarantiaAlquiler_Crear_Endosos = '011504',

  //Configuración (17)
  Administrador_Configuracion_Excepciones_Chasis = '011701',
  Administrador_Configuracion_Excepciones_Documento = '011702',

  //Gesttión de tarifa (18)
  Gestion_Tarifacion_Visualizar_Reglas_Globales = '011801',
  Gestion_Tarifacion_Crear_Reglas_Globales = '011802',
  Gestion_Tarifacion_Editar_Reglas_Globales = '011803',

  //???
  GeneralAutogestion_Ver_Comisiones = '3003',

  //---CORREDORES (02)

  //Cartera (03)
  Corredores_Cartera_Seguimiento_Polizas = '020301',
  Corredores_Cartera_Seguimiento_Saldos_Vencimientos = '020302',
  Corredores_Cartera_Administrar_Debito_Automatico = '020303',

  //Renovaciones (06)
  Corredores_Renovaciones_Automoviles = '020601',
  Corredores_Renovaciones_Multiseguros = '020602',
  Corredores_Renovaciones_Garantia_Alquiler = '020603',

  //Automoviles (07)
  Corredores_CotizadorAuto_SolicitudCotizacion = '020701',
  Corredores_CotizadorAuto_Crear_Endosos = '020702',

  //Multiproductos (08)
  Corredores_Multiproducto = '020801',
  Corredores_Multiproducto_Crear_Endosos = '020802',

  //Transporte (09)
  Corredores_Transporte_ReadPolicy = '020901',
  Corredores_Transporte_ReadShippment = '020902',
  Corredores_Transporte_CreateShippment = '020903',
  Corredores_Transporte_Crear_Endosos = '020904',

  //Viajes (11)
  Corredores_Viajes_Seguimiento_Polizas_Cotizaciones = '021101',

  //Fianza (13)
  Fianzas_Solicitar_Cupo = '021301',
  Fianzas_Solicitar_Poliza = '021302',

  //Garantía Alquiler (15)
  Corredores_Grantia_alquiler_solicitud = '021501',
  Corredores_Grantia_alquiler_Polizas_Cotizaciones = '021502',
  Corredores_Grantia_alquiler_Emitir_Poliza = '021503',
  Corredores_Grantia_alquiler_Crear_Endosos = '021504',

  //???
  Corredores_Ver_Comisiones = '021601',

  //---AUTOGESTIÓN (03)

  //Cartera (03)
  Autogestion_Cartera_Seguimiento_Polizas = '030301',

  //Transporte (09)
  Autogestion_Transporte_ReadPolicy = '030901',
  Autogestion_Transporte_ReadShippment = '030902',
  Autogestion_Transporte_CreateShippment = '030903',

  //---PARTNERS (04)
  Partners_Full_Access = '040001',

  //---WEB (05)
  Web_Acceso_Web_Gestion_Polizas_Datos_Personales = '050001',

  //---SERVICIOS EXTERNOS (06)
  External_Services_Consult_Debt = '060301',
  External_Services_Pay_Debt = '060302',
  External_Services_Cancel_Debt = '060303',
}
